import React from 'react';
export const tableColumns = [
    
    {
        Header: "Name of the risk factor",
        id: "riskFactorName",
        accessor: d => <div>{d.riskFactorName}</div>
    },
    {
        Header: "Type",
        id:"riskFactorType",
        accessor: d => <div>{d.riskFactorType}</div>
    },
    {
        Header: "Source",
        id: "sources",
        accessor: d => <div title=
        {d.sources ? d.sources.join(', ') : ''} className="wordbreak">{d.sources ? d.sources.join(', ') : ''}</div>,
    },
    {
        Header: "Transformation Rule",
        id: "transformationFormula",
        accessor: p => <div title={p.transformationFormula} className="wordbreak">{p.transformationFormula}</div>,
    }
]

